import { MiniappTopbarContainer } from './topbar/MiniappTopbarContainer'
import { usePreloadTutorialVideo } from './tutorial-dialog/logic/usePreloadTutorialVideo'
import { usePageChainId } from '@/domain/hooks/usePageChainId'
import { useOpenDialog } from '@/domain/state/dialogs/hooks'
import { selectNetworkDialogConfig } from '@/features/dialogs/select-network/SelectNetworkDialog'
import { LayoutBackground } from '@/ui/layouts/app-layout/components/LayoutBackground'
import { PageNotSupportedWarning } from '@/ui/layouts/app-layout/components/PageNotSupportedWarning'
import { cn } from '@/ui/utils/style'

interface AppLayoutProps {
  children: React.ReactNode
}

export function MiniappAppLayout({ children }: AppLayoutProps) {
  const { pageSupported, pageName, supportedChainNames } = usePageChainId()
  const openDialog = useOpenDialog()
  usePreloadTutorialVideo()

  return (
    <div
      className={cn(
        // width of the content is calculated by the formula: 100% - 2*padding
        'grid min-h-screen w-full grid-cols-[1fr_calc(100%-40px)_1fr] grid-rows-[auto_auto_1fr_auto] items-start gap-x-[20px]',
        'lg:grid-cols-[1fr_min(calc(100%-128px),1312px)_1fr] lg:gap-x-[64px]',
      )}
    >
      <LayoutBackground />
      <div className="z-30 col-start-2 col-end-2 my-2 sm:mb-8 lg:mt-6 lg:mb-10">
        <MiniappTopbarContainer />
      </div>
      <main className="isolate z-20 col-span-full grid h-full grid-cols-subgrid pb-16 *:col-start-2 *:col-end-2">
        {children}
      </main>
      {!pageSupported && (
        <PageNotSupportedWarning
          pageName={pageName}
          supportedChainNames={supportedChainNames}
          openNetworkSelectDialog={() => openDialog(selectNetworkDialogConfig, {})}
        />
      )}
    </div>
  )
}
